export enum SystemFileType {
    Unknown = "Unknown",
    TimetableFile = "TimetableFile",
    StudentOptionsFile = "StudentOptionsFile",
    Folder = "Folder",
    DailyOrganiserFile = "DailyOrganiserFile",
    ArchiveFolder = "ArchiveFolder",
    ArchiveFile = "ArchiveFile",
}